import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../../style/colors';
import { ITheme } from '../../../../style/theme';
import { EventType } from '../../../../types';

interface StyleProps {
  offeringType?: EventType;
  hasExtraBanner?: boolean;
}

export const useStyles = makeStyles<ITheme, StyleProps>((theme) => ({
  root: () => ({
    height: '284px',
    width: '628px',
  }),
  detailsContainer: {
    width: '100%',
  },
  headerContainer: {
    alignItems: 'left',
  },
  fullyBooked: {
    background: colors.midYellow,
  },
  booked: {
    background: colors.lightGreen,
  },
  recommended: {
    background: colors.secondaryLightGreen,
    color: colors.secondaryDarkGreen,
  },
  offeringHeader: {
    backgroundColor: ({ offeringType }) =>
      theme.eventColors[offeringType as EventType],
  },
  hide: {
    visibility: 'hidden',
  },
  offeringHeaderScrolled: {
    '& $label': {
      flex: 0,
      paddingTop: 0,
    },
    '& $iconsContainer': {
      paddingTop: 4,
    },
    '& svg': {
      height: 20,
    },
  },
  contentContainer: {
    padding: '24px 24px 68px 24px',
  },
  mentorWrapper: {
    display: 'flex',
    padding: '16px 0',
  },
  label: {
    flex: '1 100%',
    fontWeight: 'bold',
  },
  infoWrapper: {
    paddingBottom: 24,
  },
  infoTopicsWrapper: {
    paddingBottom: 8,
  },
  infoMentorWrapper: {
    paddingTop: 24,
  },
  expansionPanel: {
    paddingBottom: 24,
    borderBottom: `1px solid ${colors.lightGray}`,
  },
  mentorInfoWrapper: {
    paddingBottom: 32,
  },
  sectionLabel: {
    fontWeight: 'bold',
    color: colors.darkGray,
    padding: '8px 0',
  },
  topicChip: {
    margin: '0 8px 8px 0',
  },
  sessionIconsContainer: {
    display: 'flex',
  },
  sessionItem: {
    width: 180,
    marginBottom: 16,
  },
  iconsContainer: {
    paddingTop: 10,
    '& $iconWrapper path': {
      fill: theme.palette.common.white,
    },
  },
  iconWrapper: {
    verticalAlign: 'middle',
    marginTop: 8,
  },
  iconLabel: {
    marginRight: 16,
  },
  descriptionWrapper: {
    padding: '8px 0',
  },
  mentorImage: {
    width: 48,
    height: 48,
    objectFit: 'cover',
    borderRadius: 60,
    marginRight: theme.spacing(2),
  },
  mentorTitleSection: {
    display: 'block',
  },
  languageLabel: {
    fontWeight: 'bold',
  },
  divider: {
    color: colors.lightGray,
  },
  icon: {
    marginRight: 4,
  },
  eventsSection: {
    padding: '8px 0',
  },
  eventsSectionTitle: {
    textTransform: 'uppercase',
    color: colors.darkGray,
  },
  eventsList: {
    paddingLeft: 0,
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'row',
    },
  },
  eventName: {
    fontWeight: 'bold',
  },
  eventLabel: {
    padding: '16px 0',
  },
  mentorSubtitle: {
    padding: '8px 0',
  },
  actionWrapper: {
    [theme.breakpoints.up('xs')]: {
      marginTop: '15%',
      width: '35%',
      textAlign: 'right',
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: 24,
      textAlign: 'center',
    },
  },
  pageHeaderLink: {
    fontWeight: 'bold',
    paddingLeft: 4,
  },
  actionLabel: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    paddingRight: 8,
    alignItems: 'center',
  },
  specializedContainer: {
    paddingTop: 24,
    display: 'flex',
    flexDirection: 'column',
  },
  specializedLabel: {
    color: colors.darkGray,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  chip: {
    marginRight: 8,
    marginBottom: 8,
  },
  videoContainer: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    maxHeight: 140,
    marginBottom: 32,
  },
  hostedCardWrapper: {
    paddingTop: 24,
  },
  educationHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  educationSubtitle: {
    paddingTop: 24,
    paddingBottom: 8,
    color: colors.darkGray,
    textTransform: 'uppercase',
  },
  line: {
    width: '100%',
    height: 1,
    backgroundColor: colors.lightGray,
    marginTop: 16,
    marginBottom: 16,
  },
  expansionPanelHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  expansionPanelTitle: {
    color: colors.darkestBlue,
    paddingLeft: 9,
    fontWeight: 700,
  },
  hostTopicsLabel: {
    color: colors.darkGray,
    fontWeight: 700,
    paddingBottom: 8,
    paddingTop: 24,
  },
  canSupport: {
    color: colors.darkGray,
  },
  yourHostLabel: {
    color: colors.darkGray,
    fontWeight: 700,
  },
}));
